import React, { memo, useEffect, useState } from 'react';
import { Bubble, SearchBox, Dropdown, Checkbox, Radio, Select, List, } from 'tea-component';
import {
  useBoolean,
  useDeepCompareEffect,
  useUpdateEffect,
} from 'ahooks';
import _ from 'lodash-es';
import SvgIcon from '@/pages/home/components/SvgIcon';
import searchStr from './utils';
import './index.scss';

interface Iprops {
  // drap title
  title: string;
  // drap内容
  content?: string;
  // 是否展示搜索，默认不展示
  nosearch?: boolean;
  // 数据源
  checkList: Array<{
    name: number | undefined | string;
    text: string;
    disabled?: boolean;
    defauletValue?: boolean;
  }>;
  // 点击回调
  onChange: <V>(value?: V) => void;
  // 搜索回调
  onSearch?: <V>(value?: V) => void;
  // 全选
  isAll?: boolean;
  // 单选|多选。默认多选
  type?: 'checkBox' | 'Radio';
}
type TArr = { [key in string]: unknown };
export default memo(({
  title,
  content,
  nosearch,
  checkList,
  onChange,
  isAll = true,
  type = 'checkBox',
  onSearch,
}: Iprops) => {
  // 表单数据源
  const [taste, setTaste] = useState<TArr[]>([]);
  // 全选高亮
  const [isAllFlag, { toggle, setTrue, setFalse }] = useBoolean(true);
  const [dataSource, setDataSource] = useState<TArr[]>();
  // 单选高亮
  const [isActive, setIsActive] = useState('2')
  useDeepCompareEffect(() => {
    setDataSource(checkList);
  }, [checkList]);
  useUpdateEffect(() => {
    let allList;
    if (isAllFlag) {
      allList = checkList.map((task) => task.name);
      setTaste(allList);
    } else {
      if (taste.length >= checkList?.length) {
        setTaste([]);
        return;
      }
      setFalse();
    }
    onChange?.(allList || taste);
    return () => { };
  }, [isAllFlag]);
  useUpdateEffect(() => {
    if (type === 'Radio') return
    const isAllActive = taste.length >= checkList?.length;
    if (!_.isEmpty(taste) && isAllActive) {
      setTrue();
    } else {
      setFalse();
    }
    return () => { };
  }, [taste]);


  const handleOnSearch = _.debounce((value?: string) => {
    const list = searchStr(value || '', checkList);
    setDataSource(list);
    onSearch?.(value);
  }, 300);

  const handleOnClear = () => {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      setDataSource(checkList);
    }, 400);
  };

  const handleOnChange = (value?: string[] | string) => {
    setTaste(value);
    onChange?.(value);
  }

  const handleListClick = (value: string) => {
    setIsActive(value)
    handleOnChange(value)
  }
  return (
    <div className="dbi-tableselect">
      <Dropdown
        boxClassName={`dbi-tableselect-${nosearch ? 'noselect' : 'select'}`}
        className="dbi-tableselect-card"
        appearance="pure"
        trigger="hover"
        clickClose={false}
        button={
          <div className="dbi-tableselect-head">
            <Bubble dark content={content}>
              <div className="dbi-tableselect-title">{title}</div>
            </Bubble>
            <SvgIcon className="dbi-tableselect-icon" type="arrow-down" />
          </div>
        }
        onClose={handleOnClear}
      >
        {!nosearch ? (
          <SearchBox
            className="dbi-tableselect-search"
            onSearch={handleOnSearch}
            onClear={handleOnClear}
            onHelp={() => console.log('help')}
            placeholder="Search"
          />
        ) : (
          ''
        )}
        {/* TODO:有时间合并一下.抽离成小组件 */}
        {type === 'checkBox' && (
          <Checkbox.Group
            className="dbi-tableselect-checkbox"
            value={taste}
            onChange={handleOnChange}
          >
            {isAll && (
              <Checkbox value={isAllFlag} onClick={toggle} indeterminate={taste.length >= checkList?.length ? false : taste.length > 0}>
                {'All'}
              </Checkbox>
            )}
            {dataSource?.map((e, index) => (
              <Checkbox
                name={e.name}
                key={index}
                value={e?.name}
                disabled={e?.disabled}
              >
                {e.text}
              </Checkbox>
            ))}
          </Checkbox.Group>
        )}
        {type === 'Radio' && (
          <List type="option">
            {dataSource?.map((e, i) => (
              <List.Item key={i} selected={e.name === isActive} onClick={() => handleListClick(e.name)}>
                {e.text}
              </List.Item>
            ))}
          </List>
        )}
      </Dropdown>
    </div>
  );
});
